import { ProtocolBase } from '../../types/protocol.js';
import { RecordWithProtocolBase } from '../../types/recordWithProtocol.js';
import { SpcOverridesMap, SpcResultsPos } from '../../types/spc.js';
import { aggregateSpcChecks } from './aggregateSpcChecks.js';
import { extractPositionForSpc } from './extractPositionForSpc.js';
import { getControlValues } from './getControlValues.js';
import { spcCheckPosition } from './spcCheckPosition.js';


export function spcCheckFull<ObjectIdType = string>(
    protocol: ProtocolBase<ObjectIdType>,
    records: RecordWithProtocolBase<ObjectIdType>[],
    overrides?: SpcOverridesMap,
): SpcResultsPos<ObjectIdType>[] {

    const results: SpcResultsPos<ObjectIdType>[] = [];
    for (const position of protocol.positions) {
        if (position.type !== 'measurement') {
            continue;
        }

        // Get all relevant measurements of given position
        const posRecords = extractPositionForSpc(position, records);
        const values = posRecords.map(it => (it.recordPosition?.value ?? '') as string);

        // Get control values
        const currentOverrides = overrides?.[position.positionNumber];
        const controlValues = getControlValues(values, position, currentOverrides);

        // Get spc check results
        const spcResult = spcCheckPosition(values, controlValues);

        // Aggregate spc check results from multiple measurements of a position into single result per rule
        const aggregated = aggregateSpcChecks(spcResult);

        // Combine into single array
        const measurements = posRecords.map((posRecord, index) => ({
            ...posRecord,
            spcResult: spcResult[index],
        }));

        results.push({
            position,
            controlValues,
            aggregated,
            measurements,
        });
    }

    return results;
}
